import React, { useRef, useEffect } from 'react';
import { StandaloneSearchBox } from '@react-google-maps/api';
import useGoogleMapsLoader from './useGoogleMapsLoader';

const GoogleAutocomplete = ({ floatingLabel, placeholder, onSelect, value, onChange }) => {
  const inputRef = useRef(null);
  const searchBoxRef = useRef(null);
  const { isLoaded } = useGoogleMapsLoader();

  const onLoad = ref => {
    searchBoxRef.current = ref;
  };

  const onPlacesChanged = () => {
    const places = searchBoxRef.current.getPlaces();
    if (places.length === 0) return;
    onSelect(places[0]);
  };

  useEffect(() => {
    if (inputRef.current && typeof value === 'string') {
      inputRef.current.value = value;
    }
  }, [value]);

  return isLoaded ? (
    <StandaloneSearchBox
      onLoad={onLoad}
      onPlacesChanged={onPlacesChanged}
      options={{ types: ['address'], componentRestrictions: { country: 'us' } }}>
      <div className='input-wrapper'>
        <label className='floating-label' htmlFor='autocomplete-address'>
          {floatingLabel}
        </label>
        <input
          ref={inputRef}
          id='autocomplete-address'
          type='text'
          className='autocomplete-input'
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={{
            width: '100%',
            padding: '20px 16px 8px',
            fontSize: '16px',
          }}
        />
      </div>
    </StandaloneSearchBox>
  ) : (
    <div>Loading...</div>
  );
};

export default GoogleAutocomplete;
